import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';
import { immerable } from 'immer';

import dayjs from '../../core/configs/dayjs';

interface IMarketplaceMemberEntity {
	id: number;
	login: string;
	name: string;
	isGroup: boolean;
	avatar: AvatarEntity;
	firstName: string;
	lastName: string;
	mail: string;
	description: string;
	creationDate: dayjs.Dayjs | null;
	updateDate: dayjs.Dayjs | null;
}

const entityDefaults: IMarketplaceMemberEntity = {
	id: -1,
	login: '',
	name: '',
	isGroup: false,
	avatar: AvatarEntity.build('user'),
	firstName: '',
	lastName: '',
	mail: '',
	description: '',
	creationDate: null,
	updateDate: null,
};

export class MarketplaceMemberEntity implements IMarketplaceMemberEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public login = entityDefaults.login;
	public name = entityDefaults.name;
	public isGroup = entityDefaults.isGroup;
	public avatar = entityDefaults.avatar;
	public firstName = entityDefaults.firstName;
	public lastName = entityDefaults.lastName;
	public mail = entityDefaults.mail;
	public description = entityDefaults.description;
	public creationDate = entityDefaults.creationDate;
	public updateDate = entityDefaults.updateDate;

	public static build(
		params: Partial<IMarketplaceMemberEntity> = {}
	): MarketplaceMemberEntity {
		const instance = new MarketplaceMemberEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.login = params.login ?? entityDefaults.login;
		instance.name = params.name ?? entityDefaults.name;
		instance.isGroup = params.isGroup ?? entityDefaults.isGroup;
		instance.firstName = params.firstName ?? entityDefaults.firstName;
		instance.lastName = params.lastName ?? entityDefaults.lastName;
		instance.mail = params.mail ?? entityDefaults.mail;
		instance.description = params.description ?? entityDefaults.description;
		instance.creationDate = params.creationDate ?? entityDefaults.creationDate;
		instance.updateDate = params.updateDate ?? entityDefaults.updateDate;

		if (!params.isGroup) {
			instance.avatar = params.name
				? AvatarEntity.build(params.name)
				: AvatarEntity.build(`${params.firstName} ${params.lastName}`);
		}
		return instance;
	}
}
